import { Suspense } from 'react';
import { SportsbookWidget } from '../SportsbookWidget/SportsbookWidget';
import type { SportsbookProps } from '../SportsbookWidget/types';

type SportsbookRoutePageProps = {
  description: string;
  // Identifies the mapped page (e.g. its slug) so the widget remounts when navigating between mapped pages
  routeKey: string;
  routeParams: NonNullable<SportsbookProps['routeParams']>;
};

function SportsbookWidgetFallback() {
  return <div className="w-full min-h-screen bg-background" data-testid="sportsbook-widget-fallback" />;
}

function SportsbookRoutePage({ description, routeKey, routeParams }: SportsbookRoutePageProps) {
  return (
    <div className="min-h-screen bg-background" data-testid="sportsbook-route-page">
      <div className="pt-4 pb-10 mx-[var(--ll-container-padding)] flex flex-col gap-6">
        <p className="sr-only">{description}</p>
        <Suspense fallback={<SportsbookWidgetFallback />}>
          <SportsbookWidget key={routeKey} routeParams={routeParams} quickDepositEnabled />
        </Suspense>
      </div>
    </div>
  );
}

export { SportsbookRoutePage, type SportsbookRoutePageProps };
